export default __webpack_public_path__ + "static/media/bs3.1.25a80908.png";